// extracted by mini-css-extract-plugin
export default {"tbptTable":"TopBrowsingPagesToday_tbptTable__7A8e9"};